import { AxiosRequestConfig } from "axios";
import { Report } from "../Interfaces/TableInterfaces";
import { Packet } from "../Interfaces/commonDtos";
import { DropdownItem } from "../Interfaces/dropdownInterfaces";
import {
  IOptionGreekConstraintFormValues,
  IOptionGreekConstraintSearchParam,
  IOptionGreekSearchParam,
  IOptionsGreekConstraintTableReport,
  IOptionsGreekTableReport,
  IChartCommonSearchParam,
} from "../Interfaces/optionGreek";
import { Graph_Dto } from "../Interfaces/orderbookGraphInterfaces";
import {
  getRequest,
  getTable,
  postRequest,
  putRequest,
} from "./requestTemplates";

export const getOptionGreekTable = (
  searchParam: IOptionGreekSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<IOptionsGreekTableReport>> =>
  getTable<IOptionGreekSearchParam, IOptionsGreekTableReport>(
    "/v1/optionGreeks/table",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

export const getOptionGreekConstraintTable = (
  searchParam: IOptionGreekConstraintSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IOptionsGreekConstraintTableReport>> =>
  getTable<
    IOptionGreekConstraintSearchParam,
    IOptionsGreekConstraintTableReport
  >(
    "/v1/OptionGreeks/constraintTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const upsertOptionGreekConstraint = (
  formValues: IOptionGreekConstraintFormValues,
): Promise<Packet<boolean>> =>
  postRequest("/v1/OptionGreeks/upsertConstraint", formValues);

export const setServerRiskFreeRate = (
  riskfreeRate: string,
): Promise<Packet<boolean>> =>
  putRequest("/v1/optionGreeks/setRiskFreeRate", { riskfreeRate });

export const getRiskFreeRate = (): Promise<{ riskFreeRate: string }> =>
  getRequest("/v1/optionGreeks/getRiskFreeRate");

export const getDueDates = (insId: string): Promise<DropdownItem[]> =>
  getRequest(`v1/optionGreeks/GetDueDates?insId=${insId}`);

export const getStatuses = (): Promise<DropdownItem[]> =>
  getRequest(`v1/optionGreeks/GetStatuses`);

export const getOptionGreekChart = (
  params: IChartCommonSearchParam,
): Promise<Graph_Dto[]> => {
  return postRequest("/v1/optionGreeks/GetChartData", params);
};

export const getChainStatusChart = (
  headerName: string,
  insCode: string,
  insName: string,
  fromDate?: string,
  toDate?: string,
): Promise<Graph_Dto[]> =>
  getRequest("/v1/optionGreeks/GetChartData", {
    params: {
      HeaderName: headerName,
      InsCode: insCode,
      InsName: insName,
      From: fromDate,
      To: toDate,
    },
  });
